<ng-container *ngIf="asset">

    <div class="header">{{asset.deviceType}} {{asset.serialNumber}}</div>

    <div class="tab-container full-size">

        <mat-tab-group #tabs (selectedIndexChange)="tabChanged($event)" class="xxx" mat-align-tabs="start" mat-stretch-tabs="false">
            <mat-tab label="Asset">
                <asset-detail [asset]="asset"/>
            </mat-tab>
            <mat-tab label="Registration">
                <registration-details [assetId]="asset.assetId" />
            </mat-tab>            
            <mat-tab label="Technical details">
                <asset-technical-details [assetId]="asset.assetId" />
            </mat-tab>            
            <mat-tab label="Service recommendations">
                <asset-service-recommendations [assetId]="asset.assetId" />
            </mat-tab>
            <mat-tab label="Service events">
                <asset-service-events [assetId]="asset.assetId" />
            </mat-tab>
            <mat-tab label="Spare parts">
                <asset-spare-parts [assetId]="asset.assetId" />
            </mat-tab>
        </mat-tab-group>



    </div>

</ng-container>
